import { Component, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-contact-us-button',
  imports: [],
  template: `
    <button
      (click)="contactClick.emit()"
      class="group fixed bottom-12 left-0 z-50 hidden flex-col items-center gap-2 rounded-r-lg bg-blue-600 px-3 py-4 text-white shadow-lg transition-all duration-300 hover:bg-blue-700 hover:px-4 hover:shadow-xl md:flex"
      aria-label="Contact us"
    >
      <svg
        class="h-5 w-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
        ></path>
      </svg>
      <span class="writing-mode-vertical text-xs font-medium tracking-wider">CONTACT</span>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: contents;
    }

    .writing-mode-vertical {
      writing-mode: vertical-rl;
      text-orientation: mixed;
    }
  `,
})
export class ContactUsButtonComponent {
  contactClick = output<void>();
}
